import ContentPicker from './ContentPicker';

export default ContentPicker;
